import { ReactElement } from "react";
import { UnreachableCaseError } from "client_legacy/ndaw/errors";
import {
	AnnouncementCommentNotification,
	AnnouncementCommentReactionNotification,
	AnnouncementNotification,
	AnnouncementReactionNotification,
	AppAccessNotification,
	AvailableNotificationViewModel,
	CrossStoreNotification,
	CustomNotification,
	DocumentSharedNotification,
	EventNotification,
	EventAttendanceNotification,
	EventAttendanceNotificationKind,
	KnowledgeItemNotification,
	MaintenanceNotification,
	NewEmailNotification,
	NewMainAppPromotionNotification,
	NotificationKind,
	UserRequestNotification,
	AnnouncementCommentMentionNotification,
	CommunityPostNotification,
	CommunityPostCommentNotification,
	CommunityPostCommentMentionNotification,
	CommunityPostReactionNotification,
	CommunityPostCommentReactionNotification,
	CommunityNotification,
	EventReactionNotification,
	EventCommentNotification,
	EventCommentMentionNotification,
	EventCommentReactionNotification,
	KnowledgeItemCommentNotification,
	KnowledgeItemCommentReactionNotification,
	KnowledgeItemCommentMentionNotification,
	KnowledgeItemReactionNotification,
	CommunityMembershipNotification
} from "client/Api/Notifications/notifications";
import { AnnouncementActivityInvocation } from "./AnnouncementActivityInvocation";
import { AppAccessActivityInvocation } from "./AppAccessActivityInvocation";
import { CustomActivityInvocation } from "./CustomActivityInvocation";
import { NewEmailActivityInvocation } from "./NewEmailActivityInvocation";
import { NewMainAppPromotionActivityInvocation } from "./NewMainAppPromotionActivityInvocation";
import { UserRequestActivityInvocation } from "./UserRequestActivityInvocation";
import { AnnouncementCommentActivityInvocation } from "./AnnouncementCommentActivityInvocation";
import { DocumentSharedActivityInvocation } from "./DocumentSharedActivityInvocation";
import { KnowledgeItemActivityInvocation } from "./KnowledgeItemActivityInvocation";
import { EventActivityInvocation } from "./EventActivityInvocation";
import { MaintenanceActivityInvocation } from "./MaintenanceActivityInvocation";
import { CrossStoreActivityInvocation } from "./CrossStoreActivityInvocation";
import { EventAttendanceActivityInvocation } from "./EventAttendanceActivityInvocation";
import { CommunityPostActivityInvocation } from "./CommunityPostActivityInvocation";
import { CommunityPostCommentInvocation } from "./CommunityPostCommentInvocation";
import { EventCommentActivityInvocation } from "./EventCommentActivityInvocation";
import { KnowledgeItemCommentActivityInvocation } from "./KnowledgeItemCommentActivityInvocation";
import { CommunityActivityInvocation } from "./CommunityActivityInvocation";

export type ActivityInvocationProps = {
	activity: InvocableAvailableNotificationViewModel;
	onDismiss(shouldUpdateActivityFeed?: boolean): void;
};

export const ActivityInvocation = (props: ActivityInvocationProps): ReactElement | null => {
	const {
		activity,
		onDismiss
	} = props;

	switch (activity.kind) {
		case NotificationKind.Announcement:
			return <AnnouncementActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.AnnouncementReaction:
			return <AnnouncementActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.NewMainAppPromotion:
			return <NewMainAppPromotionActivityInvocation onDismiss={onDismiss} />;
		case NotificationKind.AppAccess:
			return <AppAccessActivityInvocation onDismiss={onDismiss} />;
		case NotificationKind.Custom:
			return <CustomActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.NewEmail:
			return <NewEmailActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.UserRequest:
			return <UserRequestActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.AnnouncementCommentReaction:
			return <AnnouncementCommentActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.AnnouncementComment:
			return <AnnouncementCommentActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.EventAttendance:
			return <EventAttendanceActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.DocumentShared:
			return <DocumentSharedActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.KnowledgeItem:
			return <KnowledgeItemActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.Event:
			return <EventActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.Maintenance:
			return <MaintenanceActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.CrossStoreOperation:
			return <CrossStoreActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.AnnouncementCommentMention:
			return <AnnouncementCommentActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.CommunityPost:
			return <CommunityPostActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.CommunityPostComment:
			return <CommunityPostCommentInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.CommunityPostCommentMention:
			return <CommunityPostCommentInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.CommunityPostReaction:
			return <CommunityPostActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.CommunityPostCommentReaction:
			return <CommunityPostCommentInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.EventReaction:
			return <EventActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.EventComment:
			return <EventCommentActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.EventCommentMention:
			return <EventCommentActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.EventCommentReaction:
			return <EventCommentActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.KnowledgeItemComment:
			return <KnowledgeItemCommentActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.KnowledgeItemCommentMention:
			return <KnowledgeItemCommentActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.KnowledgeItemCommentReaction:
			return <KnowledgeItemCommentActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.KnowledgeItemReaction:
			return <KnowledgeItemActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.Community:
			return <CommunityActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		case NotificationKind.CommunityMembership:
			return <CommunityActivityInvocation data={activity.data} onDismiss={onDismiss} />;
		default:
			throw new UnreachableCaseError(activity);
	}
};

ActivityInvocation.displayName = "ActivityInvocation";

export type InvocableAvailableNotificationViewModel =
	| AnnouncementNotification
	| NewMainAppPromotionNotification
	| AppAccessNotification
	| CustomNotification
	| NewEmailNotification
	| UserRequestNotification
	| AnnouncementCommentNotification
	| DocumentSharedNotification
	| KnowledgeItemNotification
	| MaintenanceNotification
	| AnnouncementCommentReactionNotification
	| CrossStoreNotification
	| AnnouncementReactionNotification
	| AnnouncementCommentMentionNotification
	| EventNotification
	| EventAttendanceNotification
	| CommunityPostNotification
	| CommunityPostCommentNotification
	| CommunityPostCommentMentionNotification
	| CommunityPostReactionNotification
	| CommunityPostCommentReactionNotification
	| CommunityNotification
	| CommunityMembershipNotification
	| EventReactionNotification
	| EventCommentNotification
	| EventCommentMentionNotification
	| EventCommentReactionNotification
	| KnowledgeItemCommentNotification
	| KnowledgeItemCommentReactionNotification
	| KnowledgeItemCommentMentionNotification
	| KnowledgeItemReactionNotification;

export function isInvocableAvailableNotificationViewModel(
	model: AvailableNotificationViewModel
): model is InvocableAvailableNotificationViewModel {
	switch (model.kind) {
		case NotificationKind.Unknown:
		case NotificationKind.Announcement:
		case NotificationKind.NewMainAppPromotion:
		case NotificationKind.AppAccess:
		case NotificationKind.NewEmail:
		case NotificationKind.DocumentShared:
		case NotificationKind.KnowledgeItem:
		case NotificationKind.Event:
		case NotificationKind.AnnouncementComment:
		case NotificationKind.AnnouncementReaction:
		case NotificationKind.AnnouncementCommentReaction:
		case NotificationKind.AnnouncementCommentMention:
		case NotificationKind.CommunityPostComment:
		case NotificationKind.CommunityPostCommentMention:
		case NotificationKind.CommunityPost:
		case NotificationKind.CommunityPostReaction:
		case NotificationKind.CommunityPostCommentReaction:
		case NotificationKind.Community:
		case NotificationKind.CommunityMembership:
		case NotificationKind.Maintenance:
		case NotificationKind.CrossStoreOperation:
		case NotificationKind.EventReaction:
		case NotificationKind.EventComment:
		case NotificationKind.EventCommentMention:
		case NotificationKind.EventCommentReaction:
		case NotificationKind.KnowledgeItemComment:
		case NotificationKind.KnowledgeItemCommentReaction:
		case NotificationKind.KnowledgeItemCommentMention:
		case NotificationKind.KnowledgeItemReaction:
			return true;
		case NotificationKind.EventAttendance:
			return model.data.kind !== EventAttendanceNotificationKind.Removed;
		case NotificationKind.Custom:
			return model.data.url !== "";
		case NotificationKind.UserRequest:
			return model.data.requestId !== null;
		default:
			return false;
	}
};